function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M21.609 11.429L6.869 2.715c-1.197-.708-3.031-.02-3.031 1.73v17.423c0 1.57 1.704 2.517 3.032 1.73l14.739-8.71c1.315-.775 1.319-2.684 0-3.46z",
  fill: "#246A73"
});
function SvgPlayLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}
export default SvgPlayLarge;